"use strict";
// Generated from packages/common/yrs-core/src/database_document_ids.rs.
// Do not edit. Regenerate with:
// STREAMLAIN_UPDATE_GENERATED=1 cargo test -p streamlain_yrs_core database_document_ids
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATABASE_STORAGE_VERSION = exports.DATABASE_DIRECTORY_PART_SHARDS_ARRAY_KEY = exports.DATABASE_DIRECTORY_PART_MAP_KEY = exports.DATABASE_ROW_SHARD_CONDENSE_DUE_FIELD = exports.DATABASE_ROW_SHARD_CONDENSE_MAP_KEY = exports.DATABASE_ROW_SHARD_ORDER_ARRAY_KEY = exports.DATABASE_ROW_SHARD_ROWS_MAP_KEY = exports.DATABASE_DEFAULT_ROW_SHARD_ID = exports.PAGE_PART_DOC_SEGMENT = exports.PAGE_DOC_SEGMENT = exports.DATABASE_DIRECTORY_PART_DOC_SEGMENT = exports.DATABASE_ROW_SHARD_DOC_SEGMENT = exports.DATABASE_ROOT_DOC_SEGMENT = exports.DATABASE_DOC_SEGMENT = exports.DATABASE_DOC_ID_SEPARATOR = exports.DATABASE_SYSTEM_DOC_PREFIX = void 0;
exports.DATABASE_SYSTEM_DOC_PREFIX = 'db$';
exports.DATABASE_DOC_ID_SEPARATOR = '$';
exports.DATABASE_DOC_SEGMENT = 'database';
exports.DATABASE_ROOT_DOC_SEGMENT = 'root';
exports.DATABASE_ROW_SHARD_DOC_SEGMENT = 'rows';
exports.DATABASE_DIRECTORY_PART_DOC_SEGMENT = 'dir';
exports.PAGE_DOC_SEGMENT = 'page';
exports.PAGE_PART_DOC_SEGMENT = 'part';
exports.DATABASE_DEFAULT_ROW_SHARD_ID = '00001';
exports.DATABASE_ROW_SHARD_ROWS_MAP_KEY = 'rows';
exports.DATABASE_ROW_SHARD_ORDER_ARRAY_KEY = 'rowOrder';
exports.DATABASE_ROW_SHARD_CONDENSE_MAP_KEY = 'condense';
exports.DATABASE_ROW_SHARD_CONDENSE_DUE_FIELD = 'due';
exports.DATABASE_DIRECTORY_PART_MAP_KEY = 'directoryPart';
exports.DATABASE_DIRECTORY_PART_SHARDS_ARRAY_KEY = 'directoryPartShards';
exports.DATABASE_STORAGE_VERSION = 2;
